// extracted by mini-css-extract-plugin
module.exports = {"page":"BV","pdp":"CV","cart":"DV","brand":"EV","cartModal":"FV","checkout":"GV"};